module.exports = __webpack_public_path__ + "static/media/reddit.a12da332.svg";